import React from "react";

interface ModalProps {
  title: string;
  message: string;
  onContinue: () => void;
  onSaveDraft: () => void;
  onDiscard: () => void;
}

const Modal: React.FC<ModalProps> = ({ title, message, onContinue, onSaveDraft, onDiscard }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {/* Centered Modal Box */}
      <div className="bg-white p-6 rounded-lg shadow-lg w-[350px] sm:w-[400px] text-center">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <p className="mt-2 text-gray-700">{message}</p>

        {/* Buttons Layout */}
        <div className="mt-4 flex flex-col sm:flex-row justify-center gap-3">
          <button
            className="bg-gray-300 text-gray-900 px-4 py-2 rounded-md w-full sm:w-auto"
            onClick={onContinue}
          >
            Continue
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-auto"
            onClick={onSaveDraft}
          >
            Save Draft
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded-md w-full sm:w-auto"
            onClick={onDiscard}
          >
            Discard
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
